import { FC } from "react";
import { Outlet } from "react-router-dom";
import { ChatsProvider } from "../../providers/Chats/ChatsProvider";
import { ChatsHistoryProvider } from "../../providers/Chats/ChatsHistoryProvider";
import { ChatsFeedbackAnalysisProvider } from "../../providers/Chats/ChatsFeedbackAnalysisProvider";
import { ChatsTutorialProvider } from "../../providers/Chats/ChatsTutorialProvider";
import { ChatHighlightsProvider } from "../../providers/ChatHighlights/ChatHighlightsProvider";
import { ChatToolsProvider } from "../../providers/Chats/ChatToolsProvider";
import { SectionsProvider } from "../../providers/Articles/Sections/SectionsProvider";

interface Props {
  element?: any;
  path?: string;
}

export const ChatsRoute: FC<Props> = () => {
  return (
    <ChatHighlightsProvider>
      <ChatsProvider>
        <ChatsTutorialProvider>
          <ChatsHistoryProvider>
            <ChatsFeedbackAnalysisProvider>
              <ChatToolsProvider>
                <SectionsProvider>
                  <Outlet />
                </SectionsProvider>
              </ChatToolsProvider>
            </ChatsFeedbackAnalysisProvider>
          </ChatsHistoryProvider>
        </ChatsTutorialProvider>
      </ChatsProvider>
    </ChatHighlightsProvider>
  );
};
